import FileSaver from "file-saver";
import {QUERY_LOG_DOWNLOAD} from "../../components/settings-select/actions";
import {REQUEST_SUCCESS} from "../request/requestActions";
import {getFileFormat} from "./constants";
import {
  DATASET_MVP_DOWNLOAD_METADATA_SUBMIT,
  DATASET_MVP_DOWNLOAD_SUBMIT
} from "../../state/dataset/multi-viewer-plus/actions";
import {
  DATASET_MV_DOWNLOAD_METADATA_SUBMIT,
  DATASET_MV_DOWNLOAD_SUBMIT
} from "../../state/dataset/multi-viewer/actions";
import {DATASET_SVP_DOWNLOAD_SUBMIT} from "../../state/dataset/single-viewer-plus/actions";
import {DATASET_SV_DOWNLOAD_SUBMIT} from "../../state/dataset/single-viewer/actions";
import {FILE_SAVE_GENERIC_ACTION_LABEL} from "../../state/file-save/fileSaveActions";

const fileSaveMiddleware = () => next => action => {
  const result = next(action);

  if (action.type === REQUEST_SUCCESS && action.payload.extra.fileSave) {
    if (
      action.payload.label === FILE_SAVE_GENERIC_ACTION_LABEL ||
      action.payload.label === QUERY_LOG_DOWNLOAD ||
      action.payload.label === DATASET_SV_DOWNLOAD_SUBMIT ||
      action.payload.label === DATASET_SVP_DOWNLOAD_SUBMIT ||
      action.payload.label === DATASET_MV_DOWNLOAD_SUBMIT ||
      action.payload.label === DATASET_MV_DOWNLOAD_METADATA_SUBMIT ||
      action.payload.label === DATASET_MVP_DOWNLOAD_SUBMIT ||
      action.payload.label === DATASET_MVP_DOWNLOAD_METADATA_SUBMIT ||
      action.payload.label === "itemContainer/dataset/download/submit"
    ) {
      let name = action.payload.extra.fileSave.name ?? "file";
      if (name.length > 150) {
        name = name.substring(0, 150);
      }
      if (action.payload?.extra?.responseHeaders?.partialcontent) {
        name += " - partial";
      }
      const extension = action.payload.extra.fileSave.extension
        ? action.payload.extra.fileSave.extension
        : action.payload.extra.responseHeaders["content-type"]
          ? getFileFormat(action.payload.extra.responseHeaders["content-type"])
          : "txt";

      const type = action.payload.extra.fileSave.type;

      FileSaver.saveAs(
        new Blob(
          action.payload?.extra?.stringifyResponse
            ? [JSON.stringify(action.payload.response, null, 2)]
            : [action.payload.response],
          {type: type}
        ),
        `${name}.${extension}`
      );
    }
  }

  return result;
};

export default fileSaveMiddleware;
